import { IPFontIcon } from 'baseComponents';
import { cancelIcon, checkIcon, incidentIcon } from 'globalStyles';

export enum StateIconState {
  Success = 'Success',
  Warning = 'Warning',
  Error = 'Error',
}

export enum StateIconSize {
  Small = 14,
  Medium = 20,
  Large = 32,
}

interface IStateIconProps {
  state: StateIconState;
  size?: StateIconSize;
}

export const StateIcon = (props: IStateIconProps) => {
  const { state, size = StateIconSize.Medium } = props;
  const iconStyles = {
    fontSize: size,
    color: state === StateIconState.Success ? 'green' : state === StateIconState.Warning ? 'orange' : 'red',
  };

  switch (state) {
    case StateIconState.Error:
      return <IPFontIcon {...cancelIcon} style={iconStyles} />;
    case StateIconState.Warning:
      return <IPFontIcon {...incidentIcon} style={iconStyles} />;
    case StateIconState.Success:
      return <IPFontIcon {...checkIcon} style={iconStyles} />;
    default:
      return null;
  }
};
